'use client';

import { useScreenName } from '@tuic/web-compositions/hooks/use-screen-name';
import { ImageProps, Image } from '@tuic/web-compositions/shared/Image';
import {
  getResponsiveValue,
  ResponsiveValue,
} from '@tuic/web-compositions/utils/responsive-property';
import { FC, useMemo } from 'react';

export type ResponsiveImageProps = {
  responsiveProps: ResponsiveValue<ImageProps>;
} & Omit<ImageProps, 'src' | 'alt'>;

export const ResponsiveImage: FC<ResponsiveImageProps> = ({
  responsiveProps,
  ...rest
}) => {
  const screenName = useScreenName();

  const imageProps = useMemo(() => {
    const defaultValue = Array.isArray(responsiveProps)
      ? responsiveProps[0]
      : responsiveProps;

    return getResponsiveValue(responsiveProps, defaultValue, screenName);
  }, [screenName, responsiveProps]);

  // eslint-disable-next-line jsx-a11y/alt-text
  return <Image {...imageProps} {...rest} />;
};
